const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (!subscribers[eventName]) {
    subscribers[eventName] = [];
  }
  subscribers[eventName].push(callback);

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter(cb => cb !== callback);
  };
}

function publish(eventName, data) {

  // If cart-update and data is invalid
 if (
  eventName === PUB_SUB_EVENTS.cartUpdate &&
  (!data || !data.cart || typeof data.cart.item_count === 'undefined')
) {
    console.warn('Cart data invalid, fetching real cart...');

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        // Update cart drawer if exists
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          // Optional: you can fetch section HTML if you use Shopify sections
          // drawer.innerHTML = fetchedHTML['cart-drawer'];
        }

        // Update cart bubble if exists
        const bubble = document.querySelector('#cart-icon-bubble');
        if (bubble) {
          // Optional: update bubble HTML if using sections
          // bubble.innerHTML = fetchedHTML['cart-icon-bubble'];
        }

        // Trigger all subscribers with real cart
        if (subscribers[eventName]) {
          // Re-wrap the cart inside the data payload expected by the subscribers
          if (data) {
            data.cart = cart;
          } else {
            data = { cart: cart };
          }
          
          subscribers[eventName].forEach(callback => {
            try {
              callback(data);
            } catch (e) {
              console.error('Cart callback error:', e);
            }
          });
        }
      })
      .catch(err => {
        console.error('Failed to fetch cart:', err);
      });
    return; // stop normal flow
  }
  // Normal flow for valid data
  if (subscribers[eventName]) {
    subscribers[eventName].forEach(callback => {
      try {
        callback(data);
      } catch (e) {
        console.error('Callback error:', e);
      }
    });
  }
}